<template>
    <div :style="{display:show?'block':'none'}" class="modal" style="z-index:12345;background:rgba(1,1,1,0.5);">
        <div class="col-xs-12" style="text-align:right;">
            <span class="btn btn-default" @click="closeClicked">X</span>
        </div>
        <div style="width:100%;height:80%;margin:0 auto;overflow-y:auto;border:2px solid #ddd;background:white;">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    export default {
        props:["show"],
        data: function () {
            return {};
        },
        methods: {
            closeClicked: function () {
                this.$emit("onclose");
            }
        }
    }
</script>